<script lang="ts">
	import { page } from '$app/stores';
	import { marketsConfig } from '$lib/config/markets';
	import { footerPath } from '$lib/footer/store';
	import ChartSelector from '$lib/home/ChartSelector.svelte';
	import FundingRateChart from '$lib/home/FundingRateChart/FundingRateChart.svelte';
	import MobileActiveSectionItem from '$lib/home/MobileActiveSectionItem.svelte';
	import {
		chartSelected,
		currentMarket,
		currentMarketIdentifier,
		mobileActiveSection,
		orders,
		positions
	} from '$lib/home/store';
	import TopInfoSection from '$lib/home/TopInfoSection.svelte';
	import TradingViewMain from '$lib/home/tradingView/TradingViewMain.svelte';
	import UserHistory from '$lib/home/userHoldings/UserHistory.svelte';
	import UserHoldings from '$lib/home/userHoldings/UserHoldings.svelte';
	import UserOrders from '$lib/home/userHoldings/UserOrders.svelte';
	import UserPositions from '$lib/home/userHoldings/UserPositions.svelte';
	import { mobileUserInteractDialogOpen } from '$lib/home/userInteract/store';
	import UserInteract from '$lib/home/userInteract/UserInteract.svelte';
	import UserInteractWrapper from '$lib/home/userInteract/UserInteractWrapper.svelte';
	import { getDisplayName } from '$lib/perps';
	import type { MarketIdentifiers } from '$lib/types/market';
	import { getNumBackInUnits } from '$lib/util/util';
	import { smartContractWalletAddress } from '$lib/home/scwallet/store';
	import { getEstimatedAccruedRewards } from '$lib/data/rewards';

	let innerWidth = 1000;
	let innerHeight = 0;

	let marketId: MarketIdentifiers;

	$: if ($page?.url?.searchParams?.get('market')) {
		marketId = $page.url.searchParams.get('market') as MarketIdentifiers;
	} else {
		marketId = 'sETHPERP';
	}
	$: if (marketId) {
		$currentMarketIdentifier = marketId;
	}

	function closeMobileUserInteractDialog() {
		$mobileUserInteractDialogOpen = false;
	}

	$: if ($currentMarket) {
		$footerPath = '> ' + getDisplayName($currentMarket.marketIdentifier);
	}
	$: title = $currentMarket
		? `$${getNumBackInUnits(
				$currentMarket.currentMarketPrice,
				18,
				marketsConfig[$currentMarket.asset].showDecimals
		  )} | ${getDisplayName($currentMarket.marketIdentifier)} | Polynomial Perps `
		: 'Polynomial Perps ';

	$: if ($smartContractWalletAddress) {
		getEstimatedAccruedRewards($smartContractWalletAddress);
	}
</script>

<svelte:head>
	<title>
		{title}
	</title>
	<script
		type="text/javascript"
		defer
		src="charting_library/charting_library.standalone.js"
		rel="preconnect"
	></script>
</svelte:head>

<svelte:window bind:innerWidth bind:innerHeight />
<section class="text-fx-white grow flex flex-col w-full">
	{#if innerWidth >= 640}
		<!-- Desktop View -->
		<div class="2xl:flex sm:grid grid-cols-11 w-full hidden xl:w-full h-full">
			<div class="col-span-8 flex flex-col min-h-[75vh] w-full">
				<div>
					<TopInfoSection />
					<ChartSelector />
					{#if $chartSelected == 'TradingView'}
						<TradingViewMain />
					{:else if $chartSelected == 'FundingRate'}
						<FundingRateChart />
					{/if}
				</div>
				<UserHoldings />
			</div>
			<div class="2xl:w-[550px] col-span-3 flex flex-col gap-2">
				<UserInteractWrapper />
			</div>
		</div>
	{:else}
		<!-- Mobile View -->
		<div class=" flex flex-grow flex-col">
			<TopInfoSection />
			<UserInteract />
			<div class="border-t border-fx-grey-800 mt-4 mb-2" />
			<div class="flex gap-2 text-fx-grey-400 font-medium text-xs px-2 py-2 mt-4">
				<MobileActiveSectionItem title="Positions" count={$positions.data?.length} />
				<MobileActiveSectionItem title="Orders" count={$orders.data?.length} />
				<MobileActiveSectionItem title="History" />
				<MobileActiveSectionItem title="Chart" />
			</div>
			{#if $mobileActiveSection == 'Chart'}
				<div class="h-[75vh]">
					<TradingViewMain />
				</div>
			{:else if $mobileActiveSection == 'Orders'}
				<div class="w-full h-full">
					<UserOrders />
				</div>
			{:else if $mobileActiveSection == 'History'}
				<div class="w-full h-full">
					<UserHistory />
				</div>
			{:else}
				<div class="w-full h-full">
					<UserPositions />
				</div>
			{/if}
		</div>
	{/if}
</section>
